import Vue from 'vue'
import Component from 'vue-class-component'
import RemoveButton from '../buttons/RemoveButton.vue'
import convoStore from '@/store/convo/convo-store'

@Component({
  name: 'statementRemove',
  props: ['convo', 'statement'],
  components: { 'remove-button' : RemoveButton },
})
export default class StatementCommentRemove extends Vue {

  protected removeCommentStatement(): void {
    convoStore.dispatchRemoveCommentStatement(this.$props['statement'])
  }

}
